import Categories from "../../components/Categories";

export default function CategoriesScreen(){
return <Categories />
}